import { render, staticRenderFns } from "./RaceNotes.vue?vue&type=template&id=f3b2b8be"
import script from "./RaceNotes.vue?vue&type=script&lang=js"
export * from "./RaceNotes.vue?vue&type=script&lang=js"
import style0 from "./RaceNotes.vue?vue&type=style&index=0&id=f3b2b8be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports